import React from "react";
import Expandable from "../../containers/expandable";
import Loader from "../loader";
import RegionCompetition from "../regionCompetition";
import { Link } from "react-router";
import Config from "../../../config/main";
import { t } from "../../../helpers/translator";

export default function RegionTemplate() {
	let {
		sportAlias,
		data: { regionAlias = "" },
		data,
		selectorKey,
		regionId,
		gameType,
		cursor,
	} = this.props;
	if (data) {
		let Competitions = [];
		data.competitionIds.forEach(compId => {
			Competitions.push(
				<RegionCompetition
					key={compId}
					setRegionCompetitionIds={this.setRegionCompetitionIds}
					compId={compId}
					regionId={regionId}
					gameType={gameType}
					sportAlias={sportAlias}
					selectorKey={selectorKey}
				/>
			);
		});
		return (
			<li className={`${cursor && this.props.regionId === cursor ? "active" : "not"}`}>
				<Expandable
					className="sport-region-info-m"
					uiKey={sportAlias + data.regionAlias}
					setRegionCompetitionIds={this.setRegionCompetitionIds}
					initiallyExpanded={null}
					regionId={regionId}
					regionClick={true}
					sportAlias={sportAlias}
					competitionIds={data.competitionIds}
					gamesCount={data.gamesCount}
					gameType={gameType}
				>
					<div
						className={
							"flag-view-m icon-" +
							regionAlias.toLowerCase().replace(/\s/g, "")
						}
					>
						<i>{Config.regionShortNames[data.regionAlias]}</i>
					</div>
					<div className="country-games-info-m">
						<p>
							<i>{data.regionName}</i>
						</p>
						{sportAlias !== "all" && (
							<span>
								<b>{data.gamesCount}</b>
							</span>
						)}
					</div>
					{sportAlias !== "all" && <div className="arrow-view-m" />}
				</Expandable>
				{sportAlias !== "all" && (
					<div className="competition-naw-wrapper-m">
						<div className="competition-list-view-m">
							<ul>
								{data.competitionIds.length > 1 && (
									<li key={"all"}>
										<Link
											to={`/${gameType}/${sportAlias}/${
												sportAlias === "all"
													? regionAlias
													: regionId
											}/all`}
											activeClassName={"active"}
											onClick={() =>
												this.setRegionCompetitionIds(
													data.regionId
												)
											}
										>
											<p>
												<span>{t("All")}</span>
											</p>
										</Link>
									</li>
								)}
								{Competitions}
							</ul>
						</div>
					</div>
				)}
			</li>
		);
	} else {
		return <Loader component="terminal/components/region" />;
	}
}
